import { render, staticRenderFns } from "./NotAuthorised.vue?vue&type=template&id=12cc2e46&scoped=true&"
import script from "./NotAuthorised.vue?vue&type=script&lang=ts&"
export * from "./NotAuthorised.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12cc2e46",
  null
  
)

export default component.exports